import { IsString, MaxLength } from "class-validator";

export class UserSearchDTO {
    
    @IsString()
    @MaxLength(50)
    name: string;

}
